import { render, staticRenderFns } from "./AutocompleteMedParams.vue?vue&type=template&id=ace53572&scoped=true"
import script from "./AutocompleteMedParams.vue?vue&type=script&lang=js"
export * from "./AutocompleteMedParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace53572",
  null
  
)

export default component.exports